/**
 * Fixed-capacity buffer. Collectors run for the whole lifetime of the page, so
 * every one of them writes into one of these — an unbounded array on a
 * long-lived tab with a chatty console is a memory leak we would be shipping
 * into our own sites.
 */
export class RingBuffer<T> {
  readonly #items: T[] = [];

  constructor(private readonly capacity: number) {}

  push(item: T): void {
    if (this.#items.length >= this.capacity) {
      this.#items.shift();
    }
    this.#items.push(item);
  }

  toArray(): T[] {
    return [...this.#items];
  }

  clear(): void {
    this.#items.length = 0;
  }

  get size(): number {
    return this.#items.length;
  }
}
